import { render } from "./DadosPessoais.vue?vue&type=template&id=1b5cef9b&scoped=true"
import script from "./DadosPessoais.vue?vue&type=script&lang=js"
export * from "./DadosPessoais.vue?vue&type=script&lang=js"

import "./DadosPessoais.vue?vue&type=style&index=0&id=1b5cef9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5cef9b"]])

export default __exports__